import { render, staticRenderFns } from "./LineUpSection.vue?vue&type=template&id=6c67d6f4&scoped=true"
import script from "./LineUpSection.vue?vue&type=script&lang=js"
export * from "./LineUpSection.vue?vue&type=script&lang=js"
import style0 from "./LineUpSection.vue?vue&type=style&index=0&id=6c67d6f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67d6f4",
  null
  
)

export default component.exports